import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('VBroker',{key:`broker-${_vm.deal.refid}`,attrs:{"deal":_vm.deal}})],1)],1)],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VRow,[_c(VCol,{attrs:{"x12":""}},[_c('VDealProperties',{key:`properties-${_vm.deal.refid}`,attrs:{"deal":_vm.deal}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }